import { formatDateISO } from "../../../../Moduels/attendance/attendanceService";

/** Earliest shift start for “day has begun” gating (local time). */
export const SHIFT_START_HOUR = 6;
export const SHIFT_START_MINUTE = 0;

export function todayIso() {
  return formatDateISO(new Date());
}

export function getDayTemporalState(dateStr) {
  const today = todayIso();
  if (dateStr < today) return "past";
  if (dateStr > today) return "future";
  return "today";
}

export function isBeforeShiftStart(now = new Date()) {
  const h = now.getHours();
  const m = now.getMinutes();
  if (h < SHIFT_START_HOUR) return true;
  if (h === SHIFT_START_HOUR && m < SHIFT_START_MINUTE) return true;
  return false;
}

/**
 * Controls heatmap / detail visibility by calendar day.
 * @returns {{ mode: 'full'|'not_started'|'future_empty'|'future_holiday' }}
 */
export function getAttendanceDisplayMode(dateStr, record) {
  const temporal = getDayTemporalState(dateStr);

  if (temporal === "past") {
    return { mode: "full" };
  }

  if (temporal === "future") {
    if (record?.status === "holiday") {
      return { mode: "future_holiday" };
    }
    return { mode: "future_empty" };
  }

  if (isBeforeShiftStart()) {
    return { mode: "not_started" };
  }

  return { mode: "full" };
}

export function isDayPillDisabled(dateStr) {
  return getDayTemporalState(dateStr) === "future";
}

export function isFutureSelectedDay(dateStr) {
  return getDayTemporalState(dateStr) === "future";
}
